import React from "react";
import { useState,useEffect } from "react";
import FileBase from 'react-file-base64';
import { useDispatch,useSelector } from "react-redux";
import {createPost,updatePost} from '../../actions/posts.js';
import useStyles from './styles.js';
import { TextField ,Button , Typography,Paper } from "@material-ui/core";
import { useNavigate } from "react-router-dom";


const Form = ({currentId,setCurrentId}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const post = useSelector((state) => (currentId ? state.posts.posts.find((message) => message._id === currentId) : null));
  const [postData,setPostData] = useState({
    title:'',
    message:'',
    tags:'',
    selectedFile:''
  });
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('profile'));


  useEffect(()=>{
    if(post) setPostData(post);
  },[post])

  const handleSubmit = (e) =>{

    e.preventDefault();

    if(currentId){
      dispatch(updatePost(currentId,{...postData,name:user?.result?.name}));
    }

    else{
      dispatch(createPost({...postData,name:user?.result?.name},navigate));
    }

    clear();

    


  }


  const clear = () => {

      setCurrentId(null);
      setPostData({
        title:'',
        message:'',
        tags:'',
        selectedFile:''
      })


  }

  if(!user?.result?.name){

    return(
      <Paper className={classes.paper}>
        <Typography variant="h6" align="center">

        Please Sign In to create and like the Memories!!!

        </Typography>

      </Paper>
    )



  }


  return (
    <Paper className={classes.paper} elevation={6}>
      <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
      <Typography variant="h6">{currentId?"Editing":"Creating"} A Memory!!!</Typography>
      <TextField name="title" variant="outlined" label="Title" fullWidth value={postData.title} onChange={(e)=>{setPostData({...postData , title:e.target.value})}} />
      <TextField name="message" variant="outlined" label="Message" fullWidth value={postData.message} onChange={(e)=>{setPostData({...postData , message:e.target.value})}} />
      <TextField name="tags" variant="outlined" label="Tags" fullWidth value={postData.tags} onChange={(e)=>{setPostData({...postData , tags:e.target.value.split(",")})}} />
      <div className={classes.fileInput}> <FileBase type="file" multiple={false} onDone={({base64})=>{setPostData({...postData , selectedFile:base64})}}/></div>
      <Button className={classes.buttonSubmit} variant="contained" color="primary" type="submit" size="large" fullWidth>Submit</Button>
      <Button variant="contained" color="secondary" onClick={clear} size="large" fullWidth>Clear</Button>
      </form>

   </Paper>
  )
}

export default Form